<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Extra-dim Overlay (same as login/reset) -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <!-- =========================
       CONTENT LAYER (Split Screen)
  =========================== -->
  <div class="container-fluid position-relative z-1 min-vh-100">
    <div class="row d-flex min-vh-100">

      <!-- Left illustration/marketing column (show from md and up) -->
      <div class="col-6 col-md-6 d-none d-md-flex bg-warning text-white login-panel-left">
        <div class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 px-5">
          <div class="absolute-top-left">
            <router-link
              to="/"
              class="auth-logo mb-2 text-decoration-none d-inline-block"
              aria-label="NPI Home"
            ></router-link>
          </div>

          <h3 class="fw-bold mb-4 text-dark">
            Manage Your B-BBEE Compliance with Confidence
          </h3>
          <p class="text-dark text-sm">
            Track programmes, prepare audit packs, and achieve your target BEE level with our comprehensive platform.
          </p>
        </div>
      </div>

      <!-- Right column: reset complete card (same structure as login/reset) -->
      <div class="col-12 col-md-6 d-flex align-items-center justify-content-center vh-100 flex-column">
        <div class="p-4 p-md-5 login-panel">

          <!-- Heading -->
          <h3 class="fw-bold mb-1 text-white">
            Password Reset Complete
          </h3>

          <p class="text-white-50 mb-4 text-sm">
            Your password has been successfully reset.
            You can now log in using your new credentials.
          </p>

          <!-- SUCCESS MESSAGE -->
          <div
            v-if="success_message"
            class="alert alert-success alert-dismissible fade show rounded-3"
            role="alert"
          >
            {{ success_message }}
            <button
              type="button"
              class="btn-close"
              @click="success_message = ''"
            ></button>
          </div>

          <!-- Back To Login -->
          <router-link
            to="/login"
            class="btn btn-primary w-100 rounded-3 fw-light text-xs"
          >
            Go to Login
          </router-link>

        </div>
      </div>

    </div>
  </div>
</div>
